import { Base } from './Base'
import { Facility } from './Facility'
import { Place } from './Place'

const lookupMap: { [prefix: string]: typeof Base } = {
  fa: Facility,
  pl: Place,
}

export const guidLookup = (guid: string) => {
  const match = guid.match(/(?<prefix>.*)_.*/)
  if (match && match.groups) {
    return lookupMap[match.groups.prefix]
  }
}
